import React from "react";
import FullParagraph from "./FullParagraph";
import LeftParagraph from "./LeftParagraph";
import ImageContent from "./ImageContent";
import RightBold from "./RightBold";
import RightParagraph from "./RightParagraph";
import Foo from "./Foo";
import VideoPlayer from "./VideoPlayer";
import LeftParaRightMedia from "./LeftParaRightMedia";
import LeftMediaRightPara from "./LeftMediaRightPara";
import ExhibitionDetails from "./ExhibitionDetails";

const Components = {
  leftparagraph: LeftParagraph,
  fullparagraph: FullParagraph,
  imagecontent: ImageContent,
  rightbold: RightBold,
  rightparagraph: RightParagraph,
  foo: Foo,
  videoplayer: VideoPlayer,
  leftpararightmedia: LeftParaRightMedia,
  leftmediarightpara: LeftMediaRightPara,
  exhibitiondetails: ExhibitionDetails
};

export default block => {
  if (typeof Components[block.component] !== "undefined") {
    return React.createElement(Components[block.component], {
      key: block._uid,
      block: block
    });
  }
  return React.createElement(
    () => <div>The component {block.component} has not been created yet.</div>,
    { key: block._uid }
  );
};
